import { render } from "./ParticlesLibrary.vue?vue&type=template&id=3c855730"
import script from "./ParticlesLibrary.vue?vue&type=script&lang=js"
export * from "./ParticlesLibrary.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__